import { SOCIAL_PLATFORM_ICON_IMG_PROPS, socialPlatformIconSrc } from "@/lib/socialIcons";
import { cn } from "@/utils/cn";

/**
 * Official YouTube brand mark for the sidebar.
 *
 * lucide ships no YouTube glyph, so the nav item renders the brand artwork that is
 * already shipped for the channel icons (`public/social media icons/youtube.png`).
 * The mark is the red play button on white, so it is drawn on a small light tile:
 * that keeps it legible on the brand-coloured active background and inside the
 * collapsed (icon-only) rail without changing any other nav item.
 */
export function YouTubeNavIcon({ className }: { className?: string }) {
  const src = socialPlatformIconSrc("youtube");
  if (!src) return null;
  return (
    <span
      className={cn(
        "flex h-4 w-4 shrink-0 items-center justify-center overflow-hidden rounded-[3px] bg-white",
        className,
      )}
      data-testid="nav-youtube-brand-icon"
    >
      <img src={src} {...SOCIAL_PLATFORM_ICON_IMG_PROPS} className="h-3.5 w-3.5 object-contain" />
    </span>
  );
}
